import React from 'react'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'

const NavButton = ({children}) => <div className={`font-accent uppercase font-bold text-sm ml-8 px-2 md:px-5 py-1 border-2 cursor-pointer rounded`} style={{borderColor: '#ccc'}}>{children}</div>

const LoginButton = ({small}) => {
  const translation = useSelector(state => state.translation.data)
  const language = useSelector(state => state.system.language)

  const label = translation.AUTH.login[language.name]
  return <React.Fragment>
    {
      small === true ? (
        <Link to="/login" className="mr-1 login-button flex items-center justify-center">
          <h1 className="uppercase font-bold text-sm">{label}</h1>
        </Link>
      ) : (
        <Link to="/login" className="login-button">
          <NavButton>{label}</NavButton>
        </Link>
      )
    }
  </React.Fragment>
}

export { LoginButton }
